export default __webpack_public_path__ + "static/media/add_card.0ba95337.png";